import React from 'react';
import { Fragment } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import DialogActions from '@material-ui/core/DialogActions';
import { Dialog, DialogProps, Grid } from '@material-ui/core';
import { Markup } from 'interweave';

import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
    },
    table: {
        minWidth: 750,
    },
    title: {
        flex: '1 1 100%',
    },
    createButton: {
        backgroundColor: '#1A9FE0',
        width: 180,
        fontWeight: 800,
        textTransform: 'inherit',
        fontFamily: 'Nunito',
        fontSize: '0.688rem',
        color: '#FFFFFF',
        borderRadius: '2.5rem',
        height: 35,
        textAlign: 'center',
        marginRight: 8
    },
    bodyContent: {
        color: "#666666",
        fontWeight: 600,
        fontSize: 12,
        fontFamily: "Nunito",
        padding: 0,
        align: "center",
        maxWidth: "165px",
    },
    closeButton: {
        backgroundColor: '#EAEAEA',
        width: 140,
        fontWeight: 800,
        textTransform: 'capitalize',
        fontFamily: 'Nunito',
        fontSize: '0.688rem',
        color: '#FFFFFF',
        borderRadius: '2.5rem',
        height: 35,
        textAlign: 'center',
    },
    heading: {
        fontSize: '2rem !important',
        fontWeight: 600,
        color: 'red'
    },
    imageContainer: {
    height: 180,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
},
notificationImg: {
    maxWidth: '100%',
    maxHeight: '100%',
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
    padding: "10px"
}
}));

export default function BlackoutDialog(props: any) {
    const classes = useStyles();
    const { blackOutPopUpData } = props;
    const [scroll, setScroll] = React.useState<DialogProps['scroll']>('paper');
    const [showPopup, setShowPopup] = React.useState<boolean>(false);

    const descriptionElementRef = React.useRef<HTMLElement>(null);
    React.useEffect(() => {
        if (props.open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [props.open]);

    React.useEffect(() => {
        if (blackOutPopUpData) {
            let publishDate = blackOutPopUpData?.publishdate;
            if (publishDate) {
                const targetDate = new Date(publishDate);
                const now = new Date();
                if (now >= targetDate) {
                    setShowPopup(true);
                }
            }
        }
    }, [blackOutPopUpData])

    return (
        <Fragment>
            {
                showPopup ?
                    <Dialog
                        open={props.open}
                        scroll={scroll}
                        aria-labelledby="scroll-dialog-title"
                        aria-describedby="scroll-dialog-description"
                        fullWidth={true}
                        maxWidth={'md'}
                    >
                        <DialogTitle id="scroll-dialog-title" > <p className={classes.heading}>{blackOutPopUpData?.title}</p></DialogTitle>
                        <DialogContent dividers={scroll === 'paper'}>
                            <DialogContentText
                                id="scroll-dialog-description"
                                ref={descriptionElementRef}
                                tabIndex={-1}
                            >
                                <Grid container>
                                    <Grid item md={10} lg={10}>
                                        <Markup content={blackOutPopUpData?.Article_body} />
                                    </Grid>
                                    <Grid item md={2} lg={2}>
                                        <div className={classes.imageContainer}>
                                            <img className={classes.notificationImg} src={blackOutPopUpData?.thumbnail?.renditionList?.[0]?.resourceUri} alt='Notification' />
                                        </div>
                                    </Grid>
                                </Grid>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button variant="contained" className={classes.closeButton} color="primary"
                                onClick={() => {
                                    props.handleopenClose(false);
                                }}
                            >Acknowledged</Button>
                        </DialogActions>
                    </Dialog>
                    :
                    null
            }

        </Fragment >
    );
}